import { render, staticRenderFns } from "./GanttIframe.vue?vue&type=template&id=cda79606&scoped=true"
import script from "./GanttIframe.vue?vue&type=script&lang=js"
export * from "./GanttIframe.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cda79606",
  null
  
)

export default component.exports